import { useState } from "react";
import LeftpanelMember from "../../components/leftpanel/leftpanel-member";
import HeaderPart from "../../components/layout/header/header";
import axios from "../../axios/axios";
import { message } from "antd";
import { useEffect } from "react";
import LoadingOverlay from "react-loading-overlay";
import "./api-key.css";
const ApiKeyPage = () => {

    const [visible, setVisible] = useState(false);
    const [copied, setCopied] = useState(false);
    const [apiKey, setApiKey] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        getApiKey();
    }, []);

    const getApiKey = () => {
        setLoading(true);

        const config = {
            headers: { Authorization: `Bearer ${localStorage.getItem("AuthToken")}` },
        };

        axios
            .get("/user/get-user-api-key", config)
            .then((res) => {
                setLoading(false);
                if (res.data.status) {
                    setApiKey(res.data.data);
                }
            })
            .catch((err) => {
                setLoading(false);
                console.error(err);
                message.error("Something went wrong!!");
            });
    };
    const handleCopy = () => {
        navigator.clipboard.writeText(apiKey).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        });
    };


    return (
        <LoadingOverlay active={loading} spinner text="loading...">
            <HeaderPart />
            <div className="main_cont">
                <LeftpanelMember />
                <div className="right_cont">
                    <div className="right_banner_banner_cnt">
                        <div className="affiliate_facing">
                            <h2>API Key</h2>
                            <p>

                            </p>
                        </div>
                        <div className="row">
                            <div className="col-md-4">
                                <div className="api-key-note-box">
                                    <h4>📌 How to use your API Key</h4>
                                    <ul>
                                        <li>🔍 Click <b>View</b> to reveal your API key.</li>
                                        <li>📋 Click <b>Copy</b> to copy the key to clipboard.</li>
                                        <li>⚡ Use your API key in headers like this:</li>
                                    </ul>
                                    <div className="code-block">
                                        apiKey: YOUR_API_KEY
                                    </div>
                                    <ul>
                                        <li>🔒 Keep it secret — never share it publicly.</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="api-doc-download">
                                    <a href="https://tvi-api.s3.amazonaws.com/Corporate_Certificate_API_Documentation_Final_With_APIKey_Guide.pdf" className="api-doc-link" target="_blank" rel="noopener noreferrer">
                                        <span className="doc-icon">📄</span>
                                        <span>Download API Documentation</span>
                                    </a>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div>
                                    <div className="api-key-box">
                                        <label className="api-key-label">Your API Key</label>
                                        <div className="api-key-container">
                                            <input
                                                type={visible ? "text" : "password"}
                                                value={apiKey}
                                                readOnly
                                                className="api-key-input"
                                            />
                                            <button
                                                className="btn btn-primary"
                                                onClick={() => setVisible((prev) => !prev)}
                                            >
                                                {visible ? "Hide" : "View"}
                                            </button>
                                            <button className="copy_but" onClick={handleCopy}>
                                                {copied ? "Copied!" : "Copy"}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </LoadingOverlay>
    );
};

export default ApiKeyPage;
